import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import NewSubAdmin from '../../../pages/SubAdmins/NewSubAdmin'
import NewSubAdminPage from '../../../pages/SubAdmins/NewSubAdminPage'
import SubAdminDetails from '../../../pages/SubAdmins/SubAdminDetails/SubAdminDetails'
import SubAdminDetailsPage from '../../../pages/SubAdmins/SubAdminDetails/SubAdminDetailsPage'
import {UsersListWrapper} from './users-list/UsersList'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'User Management',
    path: '/apps/user-management/users',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const UsersPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='users'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Sub admins list</PageTitle>
              <UsersListWrapper />
            </>
          }
        />
        <Route path='users/details-page/*' element={<SubAdminDetailsPage />} />
        <Route path='users/new' element={<NewSubAdminPage />} />
      </Route>
      <Route index element={<Navigate to='/apps/user-management/users' />} />
    </Routes>
  )
}

export default UsersPage
